export class TipoTransacao {
  static Entrada = '683C2F2A-5A85-40AB-BD81-B64FF79EDD01';
  static Transferencia = 'CDE9A8D7-D1BA-4576-9A45-38A9D7E9425C';
  static Saida = 'A545748E-3427-401D-9471-D181336781AA';
}



// WEBPACK FOOTER //
// ./src/app/models/tipoTransacao.ts